module.exports = __webpack_public_path__ + "static/media/avatar-default.fc047347.png";